module.exports = __webpack_public_path__ + "static/media/icon-trash.c0a0f955.svg";